var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuotes2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 76,
    viewBox: "0 0 98 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.56,
    d: "M89.2993 6.58096C94.9605 12.5801 98 19.3085 98 30.2155C98 49.4083 84.4955 66.6106 64.857 75.1157L59.9487 67.5592C78.2791 57.6667 81.8627 44.8295 83.2918 36.7356C80.3402 38.2601 76.4763 38.792 72.6893 38.441C62.7739 37.5252 54.958 29.4039 54.958 19.3085C54.958 14.2183 56.9848 9.33652 60.5925 5.73717C64.2002 2.13782 69.0933 0.115723 74.1953 0.115723C80.0929 0.115723 85.7321 2.80271 89.2993 6.58096ZM34.3357 6.58096C39.997 12.5801 43.0365 19.3085 43.0365 30.2155C43.0365 49.4083 29.5319 66.6106 9.89344 75.1157L4.98519 67.5592C23.3155 57.6667 26.8992 44.8295 28.3282 36.7356C25.3767 38.2601 21.5127 38.792 17.7257 38.441C7.81032 37.5252 0 29.4039 0 19.3085C0 14.2183 2.02677 9.33652 5.63446 5.73717C9.24214 2.13782 14.1352 0.115723 19.2372 0.115723C25.1348 0.115723 30.7741 2.80271 34.3412 6.58096H34.3357Z",
    fill: "#C5D4F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuotes2);
export default __webpack_public_path__ + "static/media/quotes2.c37642f9231169d5f371338205a67983.svg";
export { ForwardRef as ReactComponent };